import React from 'react'

import {
  Location,
  LocationContainer,
  LocationCredits,
  LocationLogo,
  LocationTime,
} from '../common/Location'

const SidebarDeliveryLocation = ({ availableCredits, deliveryDropoff, style }) => (
  <Location style={style}>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <LocationLogo logoAlt={deliveryDropoff.restaurantName} logoLink={deliveryDropoff.logo} />
    </div>
    <LocationContainer>
      <LocationTime
        dateTime={deliveryDropoff.deliveryDateTime}
        deliveryTimeDisplay={deliveryDropoff.dropoffDisplay}
        multiLine={false}
        style={{ paddingBottom: 0, paddingRight: '5px' }}
      />
      {availableCredits && (
        <LocationCredits creditsEarned={availableCredits} style={{ paddingBottom: 0 }} />
      )}
    </LocationContainer>
  </Location>
)

SidebarDeliveryLocation.defaultProps = {
  deliveryDropoff: {},
}

export default SidebarDeliveryLocation
